import Vue from 'vue'
import Vuex from 'vuex'
import { VUE_APP_WS_URL } from '../config.js'
import i18n from '@/common/lang';
import { login } from '@/api/login.js'
import { getUserInfo } from "@/api/user";
import { listContents } from '@/api/market'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    innerWidth: 0,
    wsUrl: VUE_APP_WS_URL+"/message",
    marketWsList: [],
    currentLanguage: localStorage.getItem('language') || 'zh',
    //不显示底部导航的页面
    footerWhiteList: ["reset", "login", "register"],
    lginWhiteList: ["google"],
    isLogin: localStorage.getItem('isLogin') === 'true',
    isPc: true,
    userInfo: localStorage.getItem('userInfo')? JSON.parse(localStorage.getItem('userInfo')):{},
    token: localStorage.getItem('token')||'',
    contentsList: [],
    langIndex: 0,
    langList: [
      {
        name: '简体中文',
        value: 'zh'
      },
      {
        name: 'English',
        value: 'en'
      }
    ],
	areaCodes: [
  // 原有区号
  "+49", // 德国
  "+55", // 巴西
  "+60", // 马来西亚
  "+61", // 澳大利亚
  "+64", // 新西兰
  "+65", // 新加坡
  "+66", // 泰国
  "+81", // 日本
  "+91", // 印度
  "+852", // 香港
  "+886", // 台湾
  
  // 新增区号
  "+1",   // 美国和加拿大
  "+82",  // 韩国
  
  // 欧洲国家
  "+33",  // 法国
  "+39",  // 意大利
  "+34",  // 西班牙
  "+44",  // 英国
  "+31",  // 荷兰
  "+32",  // 比利时
  "+41",  // 瑞士
  "+43",  // 奥地利
  "+45",  // 丹麦
  "+46",  // 瑞典
  "+47",  // 挪威
  "+358", // 芬兰
  "+351", // 葡萄牙
  "+30",  // 希腊
  "+353", // 爱尔兰
  "+36",  // 匈牙利
  "+420", // 捷克
  "+421", // 斯洛伐克
  "+48",  // 波兰
  "+40",  // 罗马尼亚
  "+359", // 保加利亚
  "+385", // 克罗地亚
  "+386", // 斯洛文尼亚
  "+372", // 爱沙尼亚
  "+371", // 拉脱维亚
  "+370", // 立陶宛
  "+356", // 马耳他
  "+357", // 塞浦路斯
  "+354", // 冰岛
  "+423", // 列支敦士登
  "+377", // 摩纳哥
  "+378", // 圣马力诺
  "+379", // 梵蒂冈
  "+381", // 塞尔维亚
  "+382", // 黑山
  "+383", // 科索沃
  "+387", // 波黑
  "+389", // 北马其顿
  "+355", // 阿尔巴尼亚
  "+374", // 亚美尼亚
  "+375", // 白俄罗斯
  "+380", // 乌克兰
  "+373", // 摩尔多瓦
  "+7",   // 俄罗斯
],
    virtualStatus: localStorage.getItem('virtualStatus')||1,
    showBoard: sessionStorage.getItem('showBoard') || 0,
  },
  getters: {
    marketWsList: state => state.marketWsList,
    getMarkTypeList: () => {
      return [
        {
          label: i18n.t('Market.forex'),
          value: "1",
        },
        {
          label: i18n.t('Market.cypto'),
          value: "2"
        },
        {
          label: i18n.t('Market.stocks'),
          value: "3"
        },
        {
          label: i18n.t('Market.futures'),
          value: "4"
        },
        {
          label: i18n.t('Market.ETF'),
          value: "5"
        },
      ]
    },
    getContentList: state => state.contentsList,
    getUserInfo: state => state.userInfo,
    langList: state => state.langList,
    langIndex: state => state.langIndex,
    virtualStatus: state => state.virtualStatus,
  },
  mutations: {
    set_isLogin(state, val) {
      state.isLogin=val;
    },
    set_userInfo(state, val) {
      state.userInfo=val;
    },
    SetInnerWidth(state, val) {
      state.innerWidth=val
    },
    CHANGE_WS_MARLET(state, data) {
      state.marketWsList=data;
    },
    changeVirtual(state, val) {
      state.virtualStatus=val;
      localStorage.setItem('virtualStatus', val);
    },
    SET_LANG(state, language) {
      localStorage.setItem('language', language);
      localStorage.setItem('lang', language);
      state.currentLanguage=language;
      state.langIndex=state.langList.findIndex((item) => item.value===state.currentLanguage);
      // console.log(state.langIndex);
      // 更新 i18n 的当前语言
      // console.log(i18n);
      i18n.locale=language;



      // state.marketTypeList = state.marketTypeList
    },
    SET_IS_PC(state, val) {
      state.isPc=val;
    },
    SET_CONTENTS(state, val) {
      state.contentsList=val;
    },
    setToken(state, token) {
      state.token=token;
    },
    setShowBoard(state, val) {
      state.showBoard=val;
      sessionStorage.setItem('showBoard', val);
    }
  },
  actions: {
    listContents({ commit, state }, lang) {
      return new Promise((resolve, reject) => {
        listContents(lang).then(res => {
          if (res.code=='200') {
            commit('SET_CONTENTS', res.result);
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    loginOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('isLogin')
        commit('setToken', '')
        commit('set_isLogin', false)
        commit('set_userInfo', {})
        resolve();
      })
    },
    login({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          if (res.code=='200') {
            localStorage.setItem('token', res.result.token)
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            commit('setToken', res.result.token)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
          }
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    GET_USER_INFO({ commit, state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getUserInfo()

          if (res.code == '200') {
            // 正常更新用户信息
            localStorage.setItem('userInfo', JSON.stringify(res.result))
            localStorage.setItem('isLogin', true)
            commit('set_isLogin', true)
            commit('set_userInfo', res.result)
          }

          resolve(res)
        } catch (err) {
          console.error('🚨 [Store] 获取用户信息失败:', err)
          reject(err)
        }
      })
    },
    GET_WS_MARKET({ commit, state, dispatch }) {
      console.log('🌐 [全局WebSocket] 准备连接到:', state.wsUrl);
      try {
        return new Promise((resolve, reject) => {
          const ws=new WebSocket(state.wsUrl);
          ws.onopen=() => {
            console.log("🌐 [全局WebSocket] 市场数据WebSocket连接成功");
            resolve("连接成功");
          };
          ws.onmessage=e => {
            if (e.data.includes("[")) {
              const data=JSON.parse(e.data);
              console.log('🌐 [全局WebSocket] 收到市场数据，产品数量:', data.length);
              commit('CHANGE_WS_MARLET', data);
            }
          };
          ws.onclose=() => {
            console.log("🌐 [全局WebSocket] 市场数据WebSocket连接关闭，3秒后重连");
            // 🎯 添加自动重连机制
            setTimeout(() => {
              console.log("🌐 [全局WebSocket] 尝试重连市场数据WebSocket");
              dispatch('GET_WS_MARKET');
            }, 3000);
          };
          ws.onerror=() => {
            console.log("🌐 [全局WebSocket] 市场数据WebSocket连接出错");
            reject("连接出错");
          };
        })
      } catch (error) {
        console.error('🌐 [全局WebSocket] 捕获到异常: '+error.message);
        reject("连接出错");
      }
    }
  },
  modules: {
  }
})
